import {
  InquiryDetailSectionHeader,
  InquiryInfoCard,
  InquiryInfoCardProps,
  SkeletonLoader,
} from '@equip.health/ui';

import { Section } from '~/components/common/Section';

export interface InquiryInfoProps {
  id: string;
  isLoading: boolean;
  info: InquiryInfoCardProps;
}

export const InquiryInfo = ({ id, info, isLoading }: InquiryInfoProps) => {
  const TOPLEVEL_ID = `${id}__info`;

  return (
    <Section id={TOPLEVEL_ID}>
      <InquiryDetailSectionHeader
        id={`${TOPLEVEL_ID}-header`}
        title="Inquiry info"
      />
      <SkeletonLoader id={TOPLEVEL_ID} isLoaded={!isLoading}>
        <InquiryInfoCard {...info} />
      </SkeletonLoader>
    </Section>
  );
};
